import { useQuery } from "@tanstack/react-query";
import { fetchBookingApprovals } from "PFApp/booking/services/api";
import { formatFilters } from "PFApp/use_filtered_collection";

import { bookingApprovalsKeys } from "./query_keys";

export const useBookingApprovals = ({
  page,
  perPage = 20,
  filters,
  order
}: {
  page?: number;
  perPage?: number;
  filters?: any;
  order?: any;
}) =>
  useQuery(
    bookingApprovalsKeys.list(page, perPage, filters, order),
    async () => {
      const data = await fetchBookingApprovals(formatFilters({ filters, order, page, per_page: perPage }));

      return data;
    },
    {
      onSuccess: (data) => {
        const newData = { ...data };
        const { meta } = newData;
        meta.totalPages = Math.ceil(meta.total / perPage);
        meta.page = page;
        return data;
      }
    }
  );
